module.exports = __webpack_public_path__ + "img/rp.3a3882c6.png";